(ns common.widgets.asset-upload
  (:require ["@mui/material/Box$default" :as Box]
            [common.db.asset-upload.resumable :as asset-upload.resumable]
            [common.url-template :as url-tpl]
            [common.widgets.upload :as upload]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui upload
  [{:keys [onChange on-clear allow-macro? resumable? controlled? path] :as props}]
  (let [overlay-sub (if resumable? [:asset-upload.resumable/progress path] [:upload/state path])
        overlay-state (use-subscribe overlay-sub)
        set-overlay-state (fn [new-state success-message failure-message]
                            (rf/dispatch [:upload/change-overlay-state path new-state success-message failure-message]))
        url-context (use-subscribe [:url-context])]
    (uix/use-effect (fn []
                      (fn []
                        (rf/dispatch-sync [:asset-upload.resumable/destroy path])
                        (rf/dispatch-sync [:upload/destroy path])))
                    [path])
    ($ Box
       {:sx #js {:position "relative"}}
       ($ upload/upload
          (merge {:enableEdit true
                  :enablePreview true}
                 props
                 {:allow-macro? allow-macro?
                  :overlay-state overlay-state
                  :set-overlay-state set-overlay-state
                  :on-clear (or on-clear #(onChange ""))
                  :onChange (fn [asset]
                              (let [on-change (fn [value]
                                                (onChange value (.-name asset)))]
                                (cond
                                  controlled? (rf/dispatch [:asset-upload.resumable/set-temp-asset path asset])

                                  (and resumable? (instance? js/File asset))
                                  (asset-upload.resumable/start-upload {:uri (url-tpl/render :api/asset-upload.resumable url-context)
                                                                        :path path
                                                                        :on-change on-change
                                                                        :file asset})
                                  (instance? js/File asset)
                                  (rf/dispatch [:upload/upload-asset path on-change asset])

                                  :else (rf/dispatch [:upload/upload-link path on-change asset]))))
                  :type "single-file"})))))
